import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledToogle,
  StyledToogleInput,
  StyledToogleLabel,
  StyledToogleInputValue,
} from './styles';

const springAnimation = {
  type: 'spring',
  stiffness: 700,
  damping: 30,
};

const Toogle = ({
  onChange, checked, label, className,
}) => {
  const handleCheck = () => onChange(!checked);
  return (
    <StyledToogle onClick={handleCheck} className={className}>
      <StyledToogleInput checked={checked}>
        <StyledToogleInputValue
          checked={checked}
          layout
          transition={springAnimation}
        />
      </StyledToogleInput>
      <StyledToogleLabel>{label}</StyledToogleLabel>
    </StyledToogle>
  );
};

Toogle.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

Toogle.defaultProps = {
  className: null,
};

export default Toogle;
